const { ANSWER_205, ACCORDION_TYPE } = require("../constants/constants");

// @ commons
const { FormattedText } = require("core/i18n").i18n;

const formatTestQuestions = (immBrokerConvenienceMiFIDTest) => {
    const immTest = immBrokerConvenienceMiFIDTest.getIn(["test", "schema"]);
    let testQuestion = [];
    immTest.get("categories").forEach((category) => {
        category.get("subCategories").forEach((subCategory) => {
            subCategory.get("sections").forEach((section) => {
                section.get("questions").forEach((question) => {
                    testQuestion.push({
                        id: question.get("id"),
                        description: question.get("description"),
                        orden: question.get("orden"),
                        inputType: question.get("inputType"),
                        answer: question
                            .get("answer")
                            .toJS()
                            .map((ans) => {
                                return {
                                    id: ans.id,
                                    description: ans.description,
                                    selected: ans.selected,
                                };
                            }),
                    });
                });
            });
        });
    });
    return testQuestion;
};

const getAccordionQuestions = (questions) => {
    return questions.filter((question) => question.inputType === ACCORDION_TYPE);
};

const summaryFormat = (questions) => {
    const allowCreateItem = (answer, summaryObj) => {
        if (answer === ANSWER_205) {
            return true;
        }
        else if (Object.values(summaryObj).flat().find((e) => e && e.id === ANSWER_205)){
            return false;
        }
        else {
            return true
        };
    };

    const summaryObj = {};
    questions.categories.forEach((category) => {
        category.subCategories.forEach((subcategory) => {
            subcategory.sections.forEach((section) => {
                section.questions.forEach((question) => {
                    question.answer.forEach((answer) => {

                        const key = subcategory.name || category.name;
                        const accordionAnswersText = (
                            <FormattedText
                                value={getItemText[answer.description]}
                                injectedStrings={[question.description]}
                            />
                        );
                        if (answer.selected === "S" || question.inputType === ACCORDION_TYPE ) {
                            if (question.inputType === ACCORDION_TYPE) {
                                answer.description = getItemText[answer.description] ? accordionAnswersText : null;
                            } else {
                                answer.description = answer.description;
                            }
                            const ans = answer.selected === 'S' ? answer : null;
                            if (summaryObj[key]) {
                                summaryObj[key] = [...summaryObj[key], ans];
                            } else {
                                if (allowCreateItem(answer.id, summaryObj)) {
                                    summaryObj[key] = [ans]
                                }
                            }
                        }
                    });
                });
            });
        });
    });
    return summaryObj;
  };

const getItemText = {
    ["2 o más"]: "broker-convenienceMifidTestSummary_investmentExperienceTwiceOrMoreItem",
    1: "broker-convenienceMifidTestSummary_investmentExperienceOnceItem",
};

module.exports = {
    formatTestQuestions,
    getAccordionQuestions,
    summaryFormat,
};
